import React, { useContext, useState } from 'react';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import { Container, Paper, Box } from '@mui/material';
import { PostSignUp } from '../../utils/AxiosUtils';
import { SiteContext } from '../../utils/SiteContext';
import { styled } from '@mui/material/styles';
import StyledButton from '../../components/StyledButton';

const StyledModal = styled(Modal)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  // Make sure the modal content stays within viewport on mobile
  padding: theme.spacing(2), // gives breathing room so content isn't flush
}));

const TintedGlass = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(5),
  width: '100%',
  maxWidth: 520,                            // reasonable cap for small modals
  maxHeight: '90vh',                        // critical: cap height to viewport
  overflowY: 'auto',                        // scroll the content if it overflows
  boxSizing: 'border-box',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(3),
    maxWidth: '100%',                       // let it expand to the edge minus modal padding
  },
}));

const StyledForm = styled('form')(({ theme }) => ({
  width: '100%', // Fix IE 11 issue.
  marginTop: theme.spacing(2),
}));

const SubmitButton = styled(StyledButton)(({ theme }) => ({
  margin: theme.spacing(3, 0, 2),
}));

export default function SignUpModal({ open, setOpen, setAlertBar }) {
  const [formData, setForm] = useState({
    firstname: '',
    lastname: '',
    phone: '',
    primary_company: '',
    email: '',
    password: '',
    confirmPassword: '',
  });
  const [formCheck, setFormCheck] = useState({});
  const { loading } = useContext(SiteContext);
  const [, setLoading] = loading;

  const signup = (e) => {
    e.preventDefault();
    if (formData.password !== formData.confirmPassword) {
      setAlertBar({
        open: true,
        alertType: 'error',
        alertMsg: "Passwords don't match.",
      });
      return;
    }

    const form = {
      email: '',
      password: '',
      firstname: '',
      lastname: '',
      phone: '',
      primary_company: '',
    };
    PostSignUp(formData, setFormCheck, form, setOpen, setAlertBar, setLoading);
  };

  return (
    <StyledModal
      aria-labelledby="signup-modal-title"
      aria-describedby="signup-modal-description"
      open={open}
      onClose={() => setOpen(false)}
      closeAfterTransition
    >
      <Fade in={open}>
        {/* Box wrapper so Container doesn't add extra maxWidth constraints at tiny sizes */}
        <Box sx={{ width: '100%' }}>
          <Container maxWidth="xs">
            <TintedGlass elevation={8}>
              <Typography component="h1" variant="h5" id="signup-modal-title">
                Create new account
              </Typography>
              <StyledForm onSubmit={signup} noValidate>
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  id="fName"
                  label="First Name"
                  name="firstname"
                  autoFocus
                  onChange={(e) => setForm({ ...formData, firstname: e.target.value })}
                  error={!!(formCheck.firstname && formCheck.firstname !== '')}
                  helperText={formCheck.firstname}
                  autoComplete="given-name"
                />
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  id="lName"
                  label="Last Name"
                  name="lastname"
                  onChange={(e) => setForm({ ...formData, lastname: e.target.value })}
                  error={!!(formCheck.lastname && formCheck.lastname !== '')}
                  helperText={formCheck.lastname}
                  autoComplete="family-name"
                />
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  id="company"
                  label="Company"
                  name="primary_company"
                  onChange={(e) => setForm({ ...formData, primary_company: e.target.value })}
                  error={!!(formCheck.primary_company && formCheck.primary_company !== '')}
                  helperText={formCheck.primary_company}
                  autoComplete="organization"
                />
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  id="email"
                  label="Email Address"
                  name="email"
                  autoComplete="email"
                  onChange={(e) => setForm({ ...formData, email: e.target.value })}
                  error={!!(formCheck.email && formCheck.email !== '')}
                  helperText={formCheck.email}
                />
                <TextField
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  id="phone"
                  label="Phone Number"
                  name="phone"
                  autoComplete="tel"
                  onChange={(e) => setForm({ ...formData, phone: e.target.value })}
                  error={!!(formCheck.phone && formCheck.phone !== '')}
                  helperText={formCheck.phone}
                />
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  name="password"
                  label="Password"
                  type="password"
                  id="password"
                  autoComplete="new-password"
                  onChange={(e) => setForm({ ...formData, password: e.target.value })}
                  error={!!(formCheck.password && formCheck.password !== '')}
                  helperText={formCheck.password}
                />
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  name="confirmPassword"
                  label="Confirm Password"
                  type="password"
                  id="confirmPassword"
                  autoComplete="new-password"
                  onChange={(e) => setForm({ ...formData, confirmPassword: e.target.value })}
                  error={!!(formCheck.password && formCheck.password !== '')}
                  helperText={formCheck.password}
                />
                <SubmitButton
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  name="signup submit"
                >
                  Submit
                </SubmitButton>
              </StyledForm>
            </TintedGlass>
          </Container>
        </Box>
      </Fade>
    </StyledModal>
  );
}


